import * as Types from '@seeqdev/api/graphql/types';

export type GqlApprovalFlowSectionFragment = { __typename?: 'WorkbookGraphQL', attachments: Array<{ __typename?: 'ApprovalFlowAttachmentGraphQL', id: string, itemId: string, approvalFlowId: string, assignedBy: string, createdAt: string, archived: boolean }>, approvalFlows: Array<{ __typename?: 'ApprovalFlowGraphQL', id: string, name: string, archived: boolean, createdAt: string, updatedAt: string | undefined, steps: Array<{ __typename?: 'ApprovalFlowStepGraphQL', id: string, approvalFlowId: string, name: string, lockRequired: boolean, position: number, archived: boolean, status: Types.GqlApprovalFlowStepStatus | undefined, createdAt: string, updatedAt: string | undefined, permissions: { __typename?: 'PermissionsGraphQL', read: boolean, write: boolean, manage: boolean } }> }>, approvalFlowAssignments: Array<{ __typename?: 'ApprovalFlowAssignmentGraphQL', id: string, approvalFlowId: string, stepId: string, itemId: string, approvedBy: string, approvedAt: string }> };


export const ApprovalFlowSectionFragmentDoc = `
    fragment ApprovalFlowSection on WorkbookGraphQL {
  attachments {
    id
    itemId
    approvalFlowId
    assignedBy
    createdAt
    archived
  }
  approvalFlows {
    id
    name
    archived
    createdAt
    updatedAt
    steps {
      id
      approvalFlowId
      name
      lockRequired
      position
      archived
      status
      createdAt
      updatedAt
      permissions {
        read
        write
        manage
      }
    }
  }
  approvalFlowAssignments {
    id
    approvalFlowId
    stepId
    itemId
    approvedBy
    approvedAt
  }
}
    `;